import { Plus } from 'lucide-react';
import { Link } from 'react-router';
import { useI18nContext } from '@/i18n/i18n-react';

/**
 * Floating "Nova campanha" button of the mobile shell (SHELL-01 AC 11),
 * placed by the layout inside the main area, above the tab bar.
 */
export function NewCampaignFab({ tenantSlug }: { tenantSlug: string }) {
  const { LL } = useI18nContext();

  return (
    <Link
      to={`/${tenantSlug}/campaigns/create`}
      aria-label={LL.shell.newCampaign()}
      className="absolute bottom-4 right-4 z-30 flex size-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg outline-none transition-transform focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:scale-95"
    >
      <Plus className="size-6" />
    </Link>
  );
}
